import React from 'react';
import { FadeIn } from './FadeIn';
import { CreditCard, Download, Rocket } from 'lucide-react';
export function PricingSection() {
  return <section id="comprar" className="py-12 bg-brand-50" data-id="element-93">
      <div className="container mx-auto px-4" data-id="element-94">
        <FadeIn data-id="element-95">
          <div className="max-w-2xl mx-auto bg-white rounded-[2rem] shadow-2xl border-4 border-brand-200 overflow-hidden" data-id="element-96">
            <div className="bg-brand-500 text-center py-3" data-id="element-97">
              <span className="text-white font-bold text-base tracking-wider uppercase" data-id="element-98">
                Oferta Especial Limitada
              </span>
            </div>

            <div className="p-6 md:p-8 text-center" data-id="element-99">
              <div className="mb-4" data-id="element-100">
                <span className="text-slate-400 text-2xl line-through font-medium block mb-2" data-id="element-101">
                  Precio Anterior: $49.900 ARS
                </span>
                <div className="flex items-center justify-center gap-4" data-id="element-102">
                  <span className="text-5xl md:text-6xl font-extrabold text-slate-900" data-id="element-103">
                    $19.990
                  </span>
                  <span className="text-xl font-bold text-slate-900" data-id="element-104">ARS</span>
                </div>
                <div className="mt-4 inline-block bg-red-100 text-red-700 font-black px-4 py-1 rounded-full text-lg transform -rotate-2" data-id="element-105">
                  ¡70% OFF!
                </div>
              </div>

              <div className="space-y-3 mb-6 text-left max-w-sm mx-auto" data-id="element-106">
                <div className="flex items-center gap-3 text-slate-700 font-medium" data-id="element-107">
                  <CreditCard className="w-6 h-6 text-brand-500" data-id="element-108" />
                  <span data-id="element-109">¡Hasta 3 cuotas sin interés! 💳</span>
                </div>
                <div className="flex items-center gap-3 text-slate-700 font-medium" data-id="element-110">
                  <Download className="w-6 h-6 text-brand-500" data-id="element-111" />
                  <span data-id="element-112">
                    Entrega inmediata por PDF a tu email. ¡Descargás e imprimís
                    hoy mismo!
                  </span>
                </div>
              </div>

              <a href="https://pagos.auradigital.fun/cart/48207923118180:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-brand-500 hover:bg-brand-600 text-white text-xl md:text-2xl font-bold py-5 px-8 rounded-2xl shadow-xl shadow-brand-500/30 transition-all hover:scale-105 active:scale-95 flex items-center justify-center gap-3" data-id="element-113">
                ¡SÍ, QUIERO EL PACK AHORA! <Rocket className="w-6 h-6" data-id="element-114" />
              </a>

              <p className="mt-4 text-sm text-slate-500 flex items-center justify-center gap-2" data-id="element-115">
                🔒 Pago 100% seguro y encriptado
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}